// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__prJfs","search":"Search_search__LXhrz","icon":"Search_icon__25Ikh","iconClose":"Search_iconClose__eYTEK","disabled":"Search_disabled__wDy3H"};